/**
 * MenuNode's metadata, including of
 * icon: can be font-awesome or ViewUI Icon styles
 * title: title is used for knowing this menu node's meaning, not for displaying
 * hideInBread: is allowed to hide this node in breadcrum
 * @export
 * @class MenuNodeMeta
 */
export default class MenuNodeMeta {

  icon: string
  title: string
  hidden: boolean
  clickEvent?: () => void

  constructor(options?: {
    icon?: string,
    title?: string,
    hidden?: boolean,
    clickEvent?: () => void,
  }) {
    this.icon = options?.icon ?? ''
    this.title = options?.title ?? ''
    this.hidden = options?.hidden ?? false
    this.clickEvent = options?.clickEvent
  }
}
